module.exports = __webpack_public_path__ + "img/Group 8726.6a807f13.png";